<template>
  <div>
    <div v-if="limsds_userDetails.userEmail != null && limsds_userDetails.userEmail != ''">
      <v-row dense>
        <v-spacer></v-spacer>
        <v-col align="Right" sm="1">
          <v-menu open-on-hover top offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-icon color="orange" small v-bind="attrs" v-on="on"
                >mdi-help</v-icon
              >
            </template>

            <v-list>
              <v-list-item>
                <a :href="HelpPref" title="About This Page" target="limsds_help"
                  >About This Page</a
                ></v-list-item
              >
              <v-list-item
                ><a
                  :href="NewsLetter"
                  title="Newsletter Index"
                  target="limsds_help"
                  >Newsletter Index</a
                ></v-list-item
              >
            </v-list>
          </v-menu>
        </v-col>
      </v-row>
      <v-row dense
        >
         <v-col sm="3" class="Instructions">Date Format :-</v-col>
         <v-col sm="1">
          <v-select 
            :items="defaultValues.itemsddlDateFormat"
            label="Date Format"
            dense
            solo
            hide-details
            v-model="list.Dateformat"
          >
          </v-select>
        </v-col>
      </v-row>
      <v-row dense
        >
        <v-col sm="3" class="Instructions">Rows per page in result table :-</v-col>
        <v-col class="pr-2 pb-n2" sm="1">
          <v-text-field
            dense
            solo
            hide-details
            label="Rows per page in result table"
            v-model="list.Rowsinresulttable"
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row dense>
         <v-col sm="3" class="Instructions">Show Analysis Test Name in result table :-</v-col>
        <v-col sm="1">
          <v-select
            label="Show analysis test name in result table"
            v-model="list.Showtestintable"
            :items="defaultValues.itemsYesNo"
            item-text="name"
            item-value="id"
            dense
            solo
            hide-details
          ></v-select>
        </v-col>
      </v-row>
      <v-row dense>
        <v-col sm="3" class="Instructions">Show Lab Area in result table :-</v-col>
        <v-col sm="1">
          <v-select
            dense
            solo
            hide-details
            label="Show Lab Area in result table"
            v-model="list.Showlabareaintable"
            :items="defaultValues.itemsYesNo"
            item-text="name"
            item-value="id"
          ></v-select>
        </v-col>
      </v-row>
      <v-row dense>
        <v-col sm="3" class="Instructions">Show LIMS Internal Samples (Standards) :-</v-col>
        <v-col sm="1">
          <v-select
            dense
            solo
            hide-details
            label="Show LIMS Internal Samples (Standards)"
            v-model="list.Limsinternal"
            :items="defaultValues.itemsYesNo"
            item-text="name"
            item-value="id"
          ></v-select>
        </v-col>
      </v-row>
      <v-row dense>
         <v-col sm="3" class="Instructions">Show Completed samples only in Arrivals :-</v-col>
        <v-col sm="1">
          <v-select
            label="Show Completed samples only in Arrivals"
            dense
            solo
            hide-details
            v-model="list.Completedonly"
            :items="defaultValues.itemsYesNo"
            item-text="name"
            item-value="id"
          ></v-select>
        </v-col>
      </v-row>
      <v-row dense>
        <v-col sm="3" class="Instructions">Component Order :-</v-col>
        <v-col sm="1">
          <v-select
            label="Component Order"
            dense
            solo
            hide-details
            v-model="list.ComponentOrder"
            :items="defaultValues.itemsComponentOrder"
            item-text="name"
            item-value="id"
          ></v-select>
        </v-col>
      </v-row>
      <v-row dense>
        <v-col sm="3" class="Instructions">Number of previous samples to show in Sample Detail :-</v-col>
        <v-col sm="1">
          <v-text-field
            label="Number of previous samples to show in Sample Detail"
            dense
            solo
            hide-details
            v-model="list.Samplesback"
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row dense>
        <v-col sm="1">
          <v-btn
            rounded
            color="primary"
            dense
            solo
            dark
            v-on:click="SaveData()"
            >Save
          </v-btn></v-col
        >
        <v-col sm="2">
          <v-btn rounded color="primary" dense solo dark @click="resetAll()"
            >Reset
          </v-btn></v-col
        >
      </v-row>
    </div>
    <div v-if="limsds_userDetails.userEmail == null">
      <h3>INVALID USER !!!</h3>
      <h4>Current user is not exist in system database !!!</h4>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import uiView from "@/_mixins/ui-view-mixin";
import appMixin from "../mixins/app-mixin";
import notificationMixin from "@/_mixins/notification-mixin";
export default {
  name: "Preference",
  mixins: [uiView, appMixin, notificationMixin],
  computed: {
    preferenceComp() {
      return this.limsds_userPreference;
    },
  },
  created() {
     this.NewsLetter = this.settings.NewsLetter;
     this.HelpPref = this.settings.HelpPref;
    if (this.limsds_userDetails.userEmail != null) {
       this.UserPreference();
    }
  },
  mounted() {},
  data() {
    return {
      HelpPref: null,
      NewsLetter: null,
      user: null,
      list: {},
      defaultItem: {},
      defaultValues: {
        itemsddlDateFormat: ["dd/MM/yyyy", "mm/dd/yyyy"],
        itemsYesNo: [
          { name: "Yes", id: 1 },
          { name: "No", id: 0 },
        ],
        itemsComponentOrder: [
          { name: "Original Sort Order", id: 1 },
          { name: "Match LIMS Sort Order", id: 0 },
        ],
      },
    };
  },
  methods: {
    UserPreference() {
      let that = this;
      const link = that.settings.WAPreferenceByUser + "UserID=" + that.limsds_userDetails.userEmail;
      axios
        .get(link)
        .then((response) => {
          that.list = response.data.value[0];
          that.defaultItem = Object.assign({}, that.list);
        })
        .catch((error) => {
          this.$root.$refs.UIError.logUIerrors("Preference", "mounted", error);
        });
    },
    resetAll() {
      this.list = Object.assign({}, this.defaultItem);
    },
    SaveData() {
      let that = this;
      debugger
      const link =
        that.settings.WAUpdatePreferenceByUser +
        "UserID=" +
        this.limsds_userDetails.userEmail +
        "&dateformat=" +
        this.list.Dateformat +
        "&rowsinresulttable=" +
        this.list.Rowsinresulttable +
        "&showtestintable=" +
        this.list.Showtestintable +
        "&limsinternal=" +
        this.list.Limsinternal +
        "&completedonly=" +
        this.list.Completedonly +
        "&samplesback=" +
        this.list.Samplesback +
        "&componentOrder=" +
        this.list.ComponentOrder +
        "&showlabareaintable=" +
        this.list.Showlabareaintable;
      axios
        .get(link)
        .then((response) => {
          that.list = response.data.value[0];
        })
        .catch((err) => {
          console.error(err);
          err.preventDefault();
        })
        .finally();
      {
        that.addNotification({
          message: "User Preferences Updated",
          type: "info",
          description: "This message will be closed within 10 seconds",
          delay: 10000,
          top: true,
          right: true,
        });
      }
    },
  },
};
</script>
<style lang="scss">
.v-input input {
  max-height: 15px;
}
</style>